import {
  AfterContentInit,
  Component,
  ContentChild,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import {
  outputToObservable,
  takeUntilDestroyed,
} from '@angular/core/rxjs-interop';
import { determineIsDesktop } from '@common';
import { BasketComponent } from '../basket/basket.component';

@Component({
  selector: 'app-basket-sticky-wrapper',
  templateUrl: './basket-sticky-wrapper.component.html',
  styleUrl: './basket-sticky-wrapper.component.scss',
})
export class BasketStickyWrapperComponent implements OnInit, AfterContentInit {
  @ContentChild(BasketComponent) basket!: BasketComponent;

  private readonly destroyRef = inject(DestroyRef);

  readonly isMobile = signal(false);
  readonly isExpanded = signal(false);

  ngAfterContentInit(): void {
    if (!this.basket) {
      return;
    }

    outputToObservable(this.basket.toggled)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((collapsed: boolean) => {
        if (this.isMobile()) {
          if (collapsed) {
            this.collapse();
          } else {
            this.expand();
          }
        }
      });
  }

  ngOnInit(): void {
    determineIsDesktop()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isDesktop) => {
        this.isMobile.set(!isDesktop);
        if (isDesktop) this.collapse();
      });
  }

  toggle(): void {
    if (this.isExpanded()) {
      this.collapse();
    } else {
      this.expand();
    }

    if (!this.isExpanded()) {
      this.basket?.forceCollapse();
    }
  }

  private expand(): void {
    this.isExpanded.set(true);
    document.body.style.overflow = 'hidden';
  }

  private collapse(): void {
    this.isExpanded.set(false);
    document.body.style.overflow = '';
  }
}
